<customer-menu
  *ngIf="envGateway$ | async as currentDesc"
  class="asList"
  [value]="currentDesc">
  <customer-menu-item
    *ngFor="let env of gatewayList"
    [value]="env.desc"
    (click)="changeGateway(env)">
    <span>{{ env.desc }}</span>
  </customer-menu-item>
</customer-menu>
